import React from 'react';

const MOBILE_QUERY = '(max-width: 1023px)';

// #region useIsMobile
/**
 * Returns true when the viewport is below the `lg` breakpoint (1024px).
 * SSR-safe: defaults to false when `window` is unavailable.
 */
export const useIsMobile = (): boolean => {
    const [isMobile, setIsMobile] = React.useState<boolean>(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia(MOBILE_QUERY).matches;
    });

    React.useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mql = window.matchMedia(MOBILE_QUERY);
        const handleChange = (ev: MediaQueryListEvent) => setIsMobile(ev.matches);
        setIsMobile(mql.matches);
        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange);
            return () => mql.removeEventListener('change', handleChange);
        }
        // Safari < 14 fallback
        mql.addListener(handleChange);
        return () => mql.removeListener(handleChange);
    }, []);

    return isMobile;
};
